<template>
  <div class="uploadImg">
    <div class="upload-content">
      <div class="upload-title">
        <p>{{ upTitle }}</p>
      </div>
      <div class="uploadSec">
        <mt-button type="primary">请选择上传文件</mt-button>
        <input type="file" value id="choose" @change="onUpload" multiple />
      </div>
      <ul class="img-list">
        <li class="show-img" v-for="(item, index) in imgList" :key="index">
          <img :src="item" class="imgs" />
          <span class="isDel" @click="delImg(index)">
            <img src="../assets/img/delete_x.png" alt />
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fileList: [],
      upTitle: '',
      upNum: 0,
      uploadNum: 0,
      imgList: [],
      upImgList: [],
      isDel: true,
    }
  },
  methods: {
    // 上传操作
    onUpload(e) {
      let photoFile = e.target
      let val = e.target.value
      // 判断是否符合上传条件
      if (photoFile.files.length === 0) return false
      for (let i = 0; i < photoFile.files.length; i++) {
        this.fileAdd(photoFile.files[i], i)
      }
      e.target.value = ''
    },
    // 添加图片
    fileAdd(file, index) {
      let formFile = new FormData()
      let imgName = 'file'
      formFile.append(imgName, file)
      let name = file.name
      let size = file.size / 1024 / 1024
      let types = '.jpg,.jpeg,.png,.gif' // 文件格式
      let fileExt = name.substring(name.lastIndexOf('.')).toLowerCase()
      let result = types.indexOf(fileExt)
      if (result < 0) {
        // 验证图片格式
        this.$toast('图片格式不正确')
        return false
      }
      if (size > 10) {
        // 验证图片格式
        this.$toast('图片大小不能超过10M')
        return false
      }
      this.$http
        .post('/live/oss/upload', formFile)
        .then((res) => {
          this.upNum = this.fileList.length + 1 // 计算图片数量
          this.fileList.push(file) // 添加进图片数组
          let imgUrl = res.data.data // 图片回显地址
          let upImg = res.data.data // 传给后台的图片地址
          this.imgList.push(upImg)
          this.upImgList.push(upImg)
          let certificateUrl = this.upImgList.join(',')
          this.$emit('input', certificateUrl)
        })
        .catch((err) => {
          this.$toast('图片上传失败，请重新上传')
        })
    }, // 删除图片
    delImg(index) {
      this.imgList.splice(index, 1)
      this.fileList.splice(index, 1)
      this.upNum = this.imgList.length
      let certificateUrl = this.imgList.join(',')
      this.$emit('input', certificateUrl)
    },
  },
  watch: {
    imgList() {
      this.$emit('changeNum') // 触发父组件中验证资料是否完整的方法
    },
  },
}
</script>

<style lang="scss"  rel="stylesheet/less" scoped>
.uploadImg {
  text-align: left;
  .upload-content {
    margin-left: 0.3rem;
    .upload-title {
      display: flex;
      justify-content: space-between;
      padding: 0.3rem 0.3rem 0.3rem 0;
      .show-num {
        color: #c9c9c9;
      }
    }
    .img-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0.6rem 0.3rem 0.3rem 0;

      li {
        position: relative;
        margin: 1rem;
        width: 100%;
        .imgs {
          width: 100%;
        }
        span {
          margin: 1rem;
          position: absolute;
          border-radius: 50%;
          top: 0;
          right: 0;
          width: 2rem;
          height: 2rem;
          // background-color: #eee;
          opacity: 0.7;
          text-align: center;
          img {
            border-radius: 50%;
            width: 100%;
          }
        }
      }
    }
  }
}
.uploadSec {
  position: relative;
  overflow: hidden;
  text-align: center;
  #choose {
    position: absolute;
    height: 100%;
    left: 0;
    top: 1rem;
    opacity: 0;
  }
}
</style>
